import React, { useState } from 'react';

// ============================================================
// Identicon — avatar determinista compartido
// Muestra la foto del usuario si existe; si no hay (o si la
// imagen falla en cargar) cae a un disco de GRADIENTE único
// derivado de la semilla, con las iniciales encima.
// Mismo criterio de gradiente que el chip de identidad de
// wallet del header (WalletIdentityChip), generalizado para
// funcionar con dirección EVM O con username/nombre.
// ============================================================

// Gradiente 2-tonos estable a partir de una semilla.
export function seedGradient(seed) {
  const s = String(seed || '?');
  const hex = s.replace(/^0x/, '');
  const isAddr = /^[0-9a-fA-F]{12,}$/.test(hex);
  let hueA, hueB;
  if (isAddr) {
    // Dirección de wallet → coincide con el header (hex directo)
    hueA = parseInt(hex.slice(0, 6), 16) % 360;
    hueB = parseInt(hex.slice(6, 12), 16) % 360;
  } else {
    // Username/nombre → hash rolling 31 (sin librerías)
    let h = 0;
    for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
    hueA = h % 360;
    hueB = (h >>> 7) % 360;
  }
  return `linear-gradient(135deg, hsl(${hueA} 85% 55%), hsl(${hueB} 78% 45%))`;
}

// Iniciales (1-2 letras) desde nombre o username.
export function seedInitials(seed) {
  const s = String(seed || '').trim();
  if (!s) return '?';
  const clean = s.replace(/^0x/, '');
  const parts = clean.split(/[\s._-]+/).filter(Boolean);
  const a = parts[0]?.[0] || clean[0] || '?';
  const b = parts.length > 1 ? parts[parts.length - 1][0] : (clean[1] || '');
  return (a + b).toUpperCase();
}

export default function Identicon({ seed, src, size = 40, className = '', alt, title }) {
  const [broken, setBroken] = useState(false);
  const label = alt ?? (seed ? String(seed) : 'avatar');
  const dim = { width: size, height: size };

  if (src && !broken) {
    return (
      <img
        src={src}
        alt={label}
        title={title}
        className={className}
        onError={() => setBroken(true)}
        style={{ ...dim, borderRadius: '50%', objectFit: 'cover', display: 'block', flexShrink: 0 }}
      />
    );
  }

  return (
    <div
      className={className}
      role="img"
      aria-label={label}
      title={title}
      style={{
        ...dim,
        borderRadius: '50%',
        background: seedGradient(seed),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#fff',
        fontWeight: 700,
        fontSize: Math.max(9, Math.round(size * 0.4)),
        fontFamily: 'var(--fin-font-mono, monospace)',
        letterSpacing: '-0.02em',
        textShadow: '0 1px 2px rgba(0,0,0,0.35)',
        userSelect: 'none',
        flexShrink: 0,
      }}
    >
      {seedInitials(seed)}
    </div>
  );
}
